const updates = [
  { date: '07.28', title: '《剑尊归来》第128话更新上线', tag: '热门连载' },
  { date: '07.27', title: '新番《暗黑之城》独家首发上架', tag: '新番速递' },
  { date: '07.26', title: '《我独自升级》番外篇第3话更新', tag: '热门连载' },
  { date: '07.25', title: '国漫专区新增《斗破苍穹》年番连载', tag: '国漫专区' },
  { date: '07.24', title: '《女神降临》完结篇全卷可阅', tag: '平台公告' },
  { date: '07.23', title: '系统升级完成，阅读体验全面优化', tag: '平台公告' },
  { date: '07.22', title: '《全职猎人》韩漫版独家引进', tag: '资源上新' },
  { date: '07.21', title: '暑期追漫季活动火热进行中', tag: '平台活动' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            最新动态
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-[480px] mx-auto">
            妖精动漫网每日更新速递，精彩内容不错过
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          {updates.map((item, i) => (
            <div
              key={i}
              className="flex items-start gap-4 py-4 border-b border-background-200/70 last:border-b-0 group cursor-default"
            >
              <div className="flex-shrink-0 w-[68px] text-right">
                <span className="text-xs font-bold text-foreground-500 bg-background-200/60 px-2 py-1 rounded">
                  {item.date}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </p>
              </div>
              <div className="flex-shrink-0">
                <span className="inline-block px-2.5 py-0.5 text-xs rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}